import { ContentCopyRounded } from '@mui/icons-material';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { get } from 'lodash';

const CopyField = ({ row, field }) => {
    const value = get(row, field);

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography noWrap>{value}</Typography>
            <IconButton
                aria-label="copy"
                onClick={() => navigator.clipboard.writeText(value)}
            >
                <ContentCopyRounded fontSize="small" />
            </IconButton>
        </Box>
    );
};

export default CopyField;
